import { GroupMetadata } from 'vrlcm-gui-types';
import { Http } from 'vrlcm-gui-utils';
import { LcopsApiUri } from './uri';

interface MetadataCache {
  dataSources?: {
    [version: string]: GroupMetadata[];
  };
}

export class MetadataApi {
  private static metadataCache: MetadataCache = {};

  public static async getDataSourcesMetadata(
    version: string
  ): Promise<GroupMetadata[]> {
    const { dataSources } = MetadataApi.metadataCache;
    if (dataSources && dataSources[version]) {
      return dataSources[version];
    }
    const response = await Http.get<GroupMetadata[]>(
      LcopsApiUri.Metadata.GET_DATA_SOURCES_META_DATA_URL(version)
    );
    MetadataApi.metadataCache.dataSources = { [version]: response.data };
    return response.data;
  }

  public static async getProductPropertiesMetadata(
    productId: string,
    version: string,
    selectedProducts: string[],
    vcfEnabledEnvironment: boolean
  ) {
    const response = await Http.post<GroupMetadata[]>(
      LcopsApiUri.Metadata.GET_PRODUCT_PROPERTIES_METADATA_URL,
      {
        productName: productId,
        version,
        selectedProducts,
        vcfEnabledEnvironment
      }
    );
    return response.data;
  }

  public static async getImportProductPropertiesMetadata(
    productId: string,
    vcfEnabledEnvironment?: boolean
  ) {
    const response = await Http.get<GroupMetadata[]>(
      LcopsApiUri.Metadata.GET_IMPORT_PROPERTIES_METADATA_URL(
        productId,
        vcfEnabledEnvironment
      )
    );
    return response.data;
  }
}
